// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './framework/toastr/toastr.min.css'
import '../node_modules/font-awesome/css/font-awesome.min.css'
import autoloadPrimitives from './framework/primitives/autoload'
import { config } from './config'
import './framework/utils/formatters';
import VModal from 'vue-js-modal'
import Vuelidate from 'vuelidate/lib/index.js';
import AsyncComputed from 'vue-async-computed';
import MainPlugin from './framework/utils/main-plugin';
import BusyIndicatorPlugin from './framework/utils/busy-indicator-plugin';
import { RouteQueryPlugin } from './framework/utils/route-query-plugin';
import { ComponentLocalStoragePlugin } from './framework/utils/component-local-storage-plugin'
import {ClientTable, Event} from 'vue-tables-2';
import './assets/font/fonts.css';
import { appVersion } from './framework/utils/app-version'
import auth from './auth'
import advertiseDirective from './framework/utils/advertise-directive';
import helpDirective from './framework/utils/help-directive';
import Popover from 'vue-js-popover';
import {appConfig, loadConfig} from './app-config';
import { cobraApi } from './framework';

Vue.config.productionTip = false

Vue.use(Vuelidate);
Vue.use(AsyncComputed);
Vue.use(MainPlugin);
Vue.use(BusyIndicatorPlugin);
Vue.use(RouteQueryPlugin);
Vue.use(ComponentLocalStoragePlugin);
Vue.use(ClientTable);
Vue.use(Popover);
Vue.directive("advertise", advertiseDirective);
Vue.directive('help', helpDirective);

autoloadPrimitives();

Vue.directive('focus', {
  inserted: function(el) {
    el.focus();
  }
});

Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

var started = false;

function start() {
  if(started) return;
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    validations: {}
  });

  started = true;
}

appVersion.init()
  .then(async () => {
    await loadConfig();
    cobraApi.init(appConfig.cobra.apiUrl);
    await auth.continueSession();
    start();
  });



// WEBPACK FOOTER //
// ./src/main.js